<div class="k-widget k-tabstrip k-floatwrap k-tabstrip-top k-header">
  <div class="k-tabstrip-items-wrapper k-hstack">
    <ul class="k-reset k-tabstrip-items" >
        <li class="k-item k-state-default k-state-disabled">
            <span class="k-link"></span>
        </li>
        <li *ngFor="let link of linkList"
          id="{{link.id}}"
          [attr.class]="'k-item k-state-default ' + (link.active?'k-state-active':'')"
            >
            <a class="k-link"
              [attr.class]="'k-link ' + (link.active?'active':'') "
              [routerLink]="[link.path]">{{link.text}} </a>
        </li>
    </ul>
  </div>
</div>
